import React from 'react';

import { MuiThemeProvider } from '@material-ui/core';
import CssBaseline from '@material-ui/core/CssBaseline';
import { Switch, Route, Redirect } from 'react-router-dom';

import { getTheme } from './theme';
import settings from './settings';

import Home from './Pages/Home';
import { AnalysisBoard, ReaderAnalysisBoard, BoardEditor, BoardPositionOnlyEditor } from './Pages/Board';

class App extends React.Component {
  render() {
    return (
      <MuiThemeProvider theme={getTheme('light')}>
        <CssBaseline />
        <Switch>
          <Route path={settings.routes.HOME} exact>
            <Home />
          </Route>
          <Route path={`${settings.routes.BOARD_ANALYSIS}/:fen*`} exact>
            <AnalysisBoard />
          </Route>
          <Route path={`${settings.routes.READER_BOARD_ANALYSIS}/:fen*`} exact>
            <ReaderAnalysisBoard />
          </Route>
          <Route path={`${settings.routes.BOARD_EDITOR}/:fen*`} exact>
            <BoardEditor />
          </Route>
          <Route path={`${settings.routes.BOARD_POSITION_ONLY_EDITOR}/:position*`} exact>
            <BoardPositionOnlyEditor />
          </Route>
          <Route path={`${settings.routes.LICHESS_BOARD_ANALYSIS}/:fen*`} exact component={({match}) => {
            // using: https://stackoverflow.com/a/44563899/948918
            const fen = match?.params?.fen;
            const url = fen 
              ? `${settings.values.lichessAnalysisBoardUrl}/${fen}`
              : `${settings.values.lichessAnalysisBoardUrl}`;
            // window.location.href = url;
            window.location.replace(url);
          }}/>
          <Redirect to={settings.routes.HOME} />
        </Switch>
      </MuiThemeProvider>
    );
  }
}

export default App;
